var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotif(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Icon_notifications"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_881_742",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_881_742)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "notifications",
    d: "M4.5 18.8846V17.3847H6.3077V9.92308C6.3077 8.57821 6.72276 7.38912 7.55287 6.35578C8.38301 5.32245 9.44872 4.66156 10.75 4.37311V3.75003C10.75 3.40281 10.8714 3.10768 11.1143 2.86463C11.3571 2.62156 11.6519 2.50003 11.9988 2.50003C12.3457 2.50003 12.641 2.62156 12.8846 2.86463C13.1282 3.10768 13.25 3.40281 13.25 3.75003V4.37311C14.5512 4.66156 15.6169 5.32245 16.4471 6.35578C17.2772 7.38912 17.6922 8.57821 17.6922 9.92308V17.3847H19.5V18.8846H4.5ZM11.9983 21.6923C11.5007 21.6923 11.0753 21.5153 10.7221 21.1613C10.3689 20.8073 10.1923 20.3817 10.1923 19.8846H13.8077C13.8077 20.3833 13.6305 20.8093 13.2761 21.1625C12.9218 21.5157 12.4959 21.6923 11.9983 21.6923ZM7.80765 17.3847H16.1923V9.92308C16.1923 8.76538 15.783 7.77724 14.9644 6.95866C14.1458 6.14006 13.1577 5.73076 12 5.73076C10.8423 5.73076 9.85413 6.14006 9.03555 6.95866C8.21695 7.77724 7.80765 8.76538 7.80765 9.92308V17.3847Z",
    fill: "#1C1B1F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotif);
export default __webpack_public_path__ + "static/media/notif.2fa3e332bea044f00737b425cdb36cf2.svg";
export { ForwardRef as ReactComponent };